import { createBrowserRouter } from "react-router-dom";
import AuthPage from "./features/auth/AuthPage";
// import QRScannerPage from "./features/QrScanner/QRScannerPage";
import ChatPage from "./features/chat/ChatPage";
import AppLayoutWithSocket from './components/AppLayoutWithSocket';
import DashboardPage from "./features/dashboard/DashboardPage";
import EmployeePage from "./features/employee/EmployeePage";
import SettingsPage from "./features/company/components/SettingsPage";
import ApiCredentialsPage from "./features/apiCredentials/ApiCredentialsPage";
import BusinessHourPage from "./features/businessHour/BusinessHourPage";
import BulkUploadPage from "./features/bulkUpload/BulkUploadPage";
import BulkReportPage from "./features/bulkUpload/BulkReportPage";
import ChangePasswordPage from "./features/changePassword/ChangePasswordPage";
import ResetPasswordPage from "./features/auth/ResetPasswordPage";

const router = createBrowserRouter([
    {
        path: '/',
        element: <AppLayoutWithSocket />,
        children: [
            {
                index: true,
                element: <DashboardPage />
            },
            {
                path: 'employee',
                element: <EmployeePage />
            },
            {
                path: 'setting',
                element: <SettingsPage />
            },
            {
                path: 'api-credentials',
                element: <ApiCredentialsPage />
            },
            {
                path: 'chat/:id',
                element: <ChatPage />
            },
            {
                path: 'business-hour',
                element: <BusinessHourPage />
            },
            {
                path: 'bulk-upload',
                element: <BulkUploadPage />
            },
            {
                path: 'bulk-upload/:id/report',
                element: <BulkReportPage />
            },
            {
                path: 'change-password',
                element: <ChangePasswordPage />
            }
        ]
    },
    {
        path: '/login',
        element: <AuthPage />
    },
    {
        path: '/reset-password',
        element: <ResetPasswordPage />
    },
    {
        path: '*',
        element: <h5>Page not found</h5>
    }
]);

export default router;